import React from 'react';
import { TextField, InputAdornment, Typography } from '@mui/material';
import { NumbersOutlined, AttachMoneyOutlined } from '@mui/icons-material';
import { inputSx, FONT } from '../../styles/wizardSx';

function NumberField({ field, value, onChange, ...props }) {
  const isCurrency = field.type === 'currency';
  const currencySymbol = field.metadata?.currency_symbol || '$';

  return (
    <TextField
      fullWidth
      label={field.label}
      type="number"
      value={value || ''}
      onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
      sx={inputSx}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {isCurrency ? (
              <AttachMoneyOutlined sx={{ color: 'primary.main', fontSize: 18 }} />
            ) : (
              <NumbersOutlined sx={{ color: 'primary.main', fontSize: 18 }} />
            )}
          </InputAdornment>
        ),
        endAdornment: isCurrency && (
          <InputAdornment position="end">
            <Typography component="span" sx={{ color: 'text.secondary', fontSize: FONT.body }}>
              {currencySymbol}
            </Typography>
          </InputAdornment>
        )
      }}
      {...props}
    />
  );
}

export default NumberField;
